export const environment = {
    production: false,
    apiUrl: "https://api-homolog-chat.leadfinder.com.br/forti/api/",
    //apiUrl: "http://localhost:8080/forti/api/",
};
